import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';

import {} from '@fortawesome/pro-light-svg-icons';
import {
    faFilter,
    faSlidersV,
    faMagnifyingGlass as farMagnifyingGlass,
    faXmark as farXmark,
    faSlidersUp,
    faThumbTack
} from '@fortawesome/pro-regular-svg-icons';
import {
    faMagnifyingGlass,
    faTimes,
    faXmark,
    faBan,
    faFilter as fasFilter,
    faSlidersV as fasSlidersV,
    faBuilding,
    faBars,
    faMinus,
    faTrashCan,
    faCirclePlus,
    faWandMagicSparkles,
    faTriangleExclamation,
    faThumbTack as fasThumbtack
} from '@fortawesome/pro-solid-svg-icons';
import {} from '@fortawesome/sharp-solid-svg-icons';
library.add(
    faTriangleExclamation,
    faWandMagicSparkles,
    faMagnifyingGlass,
    faFilter,
    faTimes,
    faXmark,
    faSlidersV,
    faBan,
    fasFilter,
    fasSlidersV,
    faBuilding,
    farMagnifyingGlass,
    farXmark,
    faSlidersUp,
    faBars,
    faMinus,
    faTrashCan,
    faCirclePlus,
    fasThumbtack,
    faThumbTack
);

export default FontAwesomeIcon;
